import { IS_VERBOSE } from 'config/development'
import { ETH_MAINNET, HYPEREVM, SONIC, ZKSYNC } from './chains'
import { isDevelopment } from './env'
import { getSubgraphUrlKey } from './localStorage'
import { isProd } from './constants'

const SUBGRAPH_URLS: any = {
  [ZKSYNC]: isProd
    ? {
        stats: '/subgraph/Fox18wr9vM3knWCwpMWcvDP34s93FYx3agArYKNCYAf2',
        referrals:
          'https://api.studio.thegraph.com/query/62681/rfxr-master/version/latest',
        syntheticsStats:
          '/subgraph/Fox18wr9vM3knWCwpMWcvDP34s93FYx3agArYKNCYAf2',
        leaderboard:
          'https://api.studio.thegraph.com/query/62681/rfxl-master/version/latest',
      }
    : {
        stats:
          'https://api.studio.thegraph.com/query/62681/rfxs-internal/version/latest',
        referrals:
          'https://api.studio.thegraph.com/query/62681/rfxr-internal/version/latest',
        syntheticsStats:
          'https://api.studio.thegraph.com/query/62681/rfxs-internal/version/latest',
        leaderboard:
          'https://api.studio.thegraph.com/query/62681/rfxl-internal/version/latest',
      },
  [SONIC]: isProd
    ? {
        stats: '/subgraph/6pjq4AzojpsMWwAFYNkHPzbs79YGrbEdfKmEEqv3XidQ',
        referrals:
          'https://api.studio.thegraph.com/query/109413/rfxr-master-sonic/version/latest',
        syntheticsStats:
          '/subgraph/6pjq4AzojpsMWwAFYNkHPzbs79YGrbEdfKmEEqv3XidQ',
        leaderboard:
          'https://api.studio.thegraph.com/query/109413/rfxl-master-sonic/version/latest',
      }
    : {
        stats: '/subgraph/36ZkKBVaQ4prNjLBtXGvmLvmrUYhUayyyN7MLXUY4XJw',
        referrals:
          'https://api.studio.thegraph.com/query/62681/rfxr-internal-sonic/version/latest',
        syntheticsStats:
          '/subgraph/36ZkKBVaQ4prNjLBtXGvmLvmrUYhUayyyN7MLXUY4XJw',
        leaderboard:
          'https://api.studio.thegraph.com/query/62681/rfxl-internal-sonic/version/latest',
      },

  [HYPEREVM]: {
    stats:
      'https://api.goldsky.com/api/public/project_cmherkavz1caf01vq9sqw4h2f/subgraphs/rfxs-hyperliquidTestnet/1.0.0/gn',
    referrals:
      'https://api.goldsky.com/api/public/project_cmherkavz1caf01vq9sqw4h2f/subgraphs/rfxr-hyperliquidTestnet/1.0.0/gn',
    syntheticsStats:
      'https://api.goldsky.com/api/public/project_cmherkavz1caf01vq9sqw4h2f/subgraphs/rfxs-hyperliquidTestnet/1.0.0/gn',
    leaderboard:
      'https://api.goldsky.com/api/public/project_cmherkavz1caf01vq9sqw4h2f/subgraphs/rfxl-hyperliquidTestnet/1.0.0/gn',
  },

  common: {
    [ETH_MAINNET]: {
      chainLink: 'https://api.thegraph.com/subgraphs/name/deividask/chainlink',
    },
  },
}

export function getSubgraphUrl(chainId: number, subgraph: string) {
  if (isDevelopment()) {
    const localStorageKey = getSubgraphUrlKey(chainId, subgraph)
    const url = localStorage.getItem(localStorageKey)
    if (url) {
      IS_VERBOSE &&
        // eslint-disable-next-line no-console
        console.warn(
          '%s subgraph on chain %s url is overriden: %s',
          subgraph,
          chainId,
          url,
        )
      return url
    }
  }

  return SUBGRAPH_URLS?.[chainId]?.[subgraph]
}
